export const AddIcon = () => {
    return (
        <svg
            width="22"
            height="23"
            viewBox="0 0 22 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="11" cy="11.5" r="10.6" fill="white" stroke="#9B9B9B" strokeWidth="0.8" />
            <path d="M10.9999 7.5V15.5" stroke="#9B9B9B" strokeLinecap="round" />
            <path d="M15 11.5L7 11.5" stroke="#9B9B9B" strokeLinecap="round" />
        </svg>
    );
};
